import { render } from "./GenerateReq.vue?vue&type=template&id=fc80de08&scoped=true"
import script from "./GenerateReq.vue?vue&type=script&lang=js"
export * from "./GenerateReq.vue?vue&type=script&lang=js"

import "./GenerateReq.vue?vue&type=style&index=0&id=fc80de08&scoped=true&lang=css"

import exportComponent from "/kaam/build/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc80de08"]])

export default __exports__